/* Class and set of functions for communication with Feide and Dataporten */
import { fetchWithTimeout, fetchErrorFields } from '@/lib/fetchWithTimeout'

export class FeideTools {
  constructor(accessToken, idToken) {
    console.log(
      '-------------FeideTools---------- Constructor : (' + accessToken + ')'
    )
    // console.log(idToken)
    this.token = accessToken
    this.idToken = idToken
    this.feideUserServer = 'https://api.dataporten.no'
    this.feideGroupServer = 'https://groups-api.dataporten.no'
    this.feideAuthServer = 'https://auth.dataporten.no'
    this.feideAPIServer = 'https://api.feide.no'
    this.udirAPIServer = 'https://data-nsr.udir.no'
  }

  isLoggedIn(clientToken) {
    // console.error('=== jwtToken === (' + clientToken + ')')
    if (clientToken === undefined) {
      /*
      throw new Error({
        error: 'Not logged in (no client token) !'
      })
      */
      return false
    }
    let jwtToken
    try {
      let payload = clientToken.split('.')[1]
      payload = payload.replace(/-/g, '+').replace(/_/g, '/')
      jwtToken = JSON.parse(atob(payload))
    } catch {
      return false
    }
    // console.error('=== jwtToken')
    // console.log(jwtToken)
    let tokenExpire = jwtToken.exp
    // console.log('isLoggedIn: tokenExpire (' + tokenExpire + ')')
    if (isTokenExpired(tokenExpire)) {
      /*
      throw new Error({
        error: 'Not logged in (token expired) !'
      })
      */
      return false
    }
    return true
  }
  async getHTTPFeide(url) {
    return new Promise((resolve, reject) => {
      console.log('GET getHTTPFeide URL (%s) (%s)', url, this.token)
      let options = {
        method: 'GET',
        url: url,
        headers: {
          Authorization: `Bearer ${this.token}`,
          //          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        // mode: 'no-cors',
        // credentials: "include",
        // timeout: 30000, // 30s // controlled by the browser
        responseType: 'json', // default
        responseEncoding: 'utf8', // default
        maxRedirects: 5, // default
        'Accept-Encoding': 'gzip, compress'
        // body: "{foo: 'bar'}" //JSON.stringify(loadData),
      }

      fetchWithTimeout(options.url, options)
        .then((response) => {
          console.log('RESPONSE IS (%j)', response)
          if (!response.ok) {
            // e.g. 401 expired token - the body is an error object, not the data the callers expect
            reject({
              success: false,
              error: true,
              status: response.status,
              errorMsg: 'Feide API answered ' + response.status
            })
            return
          }
          response
            .json()
            .then((result) => {
              console.log('RESULT FROM JSON IS (%j)', result)
              resolve({ success: true, data: result })
            })
            .catch((err2) => {
              console.error('RESPONSE JSON', err2)
              reject({
                success: false,
                error: true,
                errorMsg: 'Invalid JSON from Feide: ' + err2
              })
            })
        })
        .catch((error) => {
          console.error('*** ERROR *** getHTTPFeide', {
            errorMsg: error.toString()
          })
          reject({ success: false, error: true, ...fetchErrorFields(error) })
        })
    }) // promise
  }

  async getHTTPUdir(url) {
    return new Promise((resolve, reject) => {
      console.log('GET getHTTPUdir URL (%s)', url)
      let options = {
        method: 'GET',
        url: url,
        headers: {
          //   'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        mode: 'no-cors',
        // timeout: 30000, // 30s // controlled by the browser
        responseType: 'json', // default
        responseEncoding: 'utf8', // default
        maxRedirects: 3, // default
        'Accept-Encoding': 'gzip, compress'
        // body: "{foo: 'bar'}" //JSON.stringify(loadData),
      }

      fetchWithTimeout(options.url, options)
        .then((response) => {
          console.log('getHTTPUdir RESPONSE IS (%j)', response)
          response
            .json()
            .then((result) => {
              console.log('RESULT FROM JSON IS (%j)', result)
              resolve({ success: true, data: result })
            })
            .catch((err2) => {
              console.error('RESPONSE JSON', err2)
              reject({
                success: false,
                error: true,
                errorMsg: 'Invalid JSON from Udir: ' + err2
              })
            })
        })
        .catch((error) => {
          console.error('*** ERROR *** getHTTPUdir', {
            errorMsg: error.toString()
          })
          reject({ success: false, error: true, ...fetchErrorFields(error) })
        })
    }) // promise
  }

  getUserInfo() {
    return new Promise((resolve, reject) => {
      // console.log('getUserInfo got called ! : ' + this.token)
      this.getHTTPFeide(this.feideAuthServer + '/openid/userinfo')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.error('*** ERROR *** getUserInfo:' + error)
          reject(new Error('*** ERROR *** getUserInfo:' + error))
        })
    })
  }

  getBasicUserInfo() {
    // let serverUrl = 'https://api.dataporten.no'
    console.log('getBasicUserInfo got called:')
    return new Promise((resolve, reject) => {
      this.getHTTPFeide(this.feideUserServer + '/userinfo/v1/userinfo')
        .then((response) => {
          console.log('basicUserInfo is:')
          console.log(response.data)
          resolve(response.data)
        })
        .catch((error) => {
          console.error('getBasicUserInfo had problems !: ' + error)
          reject(new Error('getBasicUserInfo had problems !: ' + error))
        })
    })
  }

  /* ********* GROUPS ********** */
  /* https://docs.feide.no/developer_oauth/technical_details/groups_api.html */
  getAllGroups() {
    return new Promise((resolve, reject) => {
      // console.log('getAllGroups got called ! : ' + this.token)
      this.getHTTPFeide(this.feideGroupServer + '/groups/me/groups')
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllGroups:' + error)
          reject(new Error('*** ERROR *** getAllGroups:' + error))
        })
    })
  }

  getGroupMembers(groupID) {
    return new Promise((resolve, reject) => {
      // console.log('getAllGroups got called ! : ' + this.token)
      this.getHTTPFeide(
        this.feideGroupServer + '/groups/groups/' + groupID + '/members'
      )
        .then((response) => {
          // console.log(response.data)
          resolve(response.data)
        })
        .catch((error) => {
          console.error('*** ERROR *** getGroupMembers:' + error)
          reject(new Error('*** ERROR *** getGroupMembers:' + error))
        })
    })
  }

  getAllOrganisations() {
    console.log('getAllOrganisations got called')
    return new Promise((resolve, reject) => {
      // console.log('getAllOrganisations got called ! : ' + this.token)
      this.getHTTPUdir(this.udirAPIServer + '/kommuner')
        .then((response) => {
          let orgs = response.data
          let activeOrgs = []
          orgs.forEach((value) => {
            if (!value.ErNedlagt && value.OrgNr) {
              activeOrgs.push({
                kommunenavn: value.Navn,
                kommuneorgnr: value.OrgNr
              })
            }
          })
          // console.log('got the following Active organisations')
          // console.log(activeOrgs)
          resolve(activeOrgs)
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllOrganisations:' + error)
          reject(new Error('*** ERROR *** getAllOrganisations:' + error))
        })
    })
  }

  getFeideShcools(kommuneorgnr) {
    // console.log('getFeideShcools got called (' + kommuneorgnr + ')')
    return new Promise((resolve, reject) => {
      if (kommuneorgnr === undefined) {
        reject(new Error('NO kommunenr defined'))
      }
      let kommunenr = kommuneorgnr.substr(2)
      // /trestruktur/940039541/1
      let query = '/trestruktur/' + kommunenr + '/1'
      this.getHTTPUdir(this.udirAPIServer + query)
        .then((response) => {
          // console.log(response.data.Children)
          let schools = response.data.Children
          let returnSchools = []
          schools.forEach((value) => {
            returnSchools.push({
              skolenavn: value.Navn,
              skoleorgnr: value.OrgNr
            })
          })
          // console.log('got the following Active organisations')
          // console.log(activeOrgs)
          resolve(returnSchools)
        })
        .catch((error) => {
          console.error('*** ERROR *** getAllOrganisations:' + error)
          reject(new Error('*** ERROR *** getAllOrganisations:' + error))
        })
    }) // promise
  }

  /* Method for extracting "groups" of a specific type [u,b] */
  getFeideGroups(groups, type) {
    groups = Array.isArray(groups) ? groups : []
    console.log('getFeideGroups (%s) (%s)', groups.length, type)
    // console.log(groups)
    /* when logging in from HE, the group model have different attributes.
     U -> Fag
     B -> Grupper/Klasser
     For HE vi må også sjekke medlemsskapet til gruppene. Noe som avgjør om det er  U eller B.
     K13 har go_type="a","b","u" - Det virker som om HE ikke har disse.
    */
    let feideGroups = []
    let length = groups.length || 0
    for (let i = 0; i < length; i++) {
      let item = groups[i] || {}
      if (item.go_type && item.go_type === type) {
        feideGroups.push(item)
      }
    }
    if (feideGroups.length === 0) {
      // School K13 was found - checking HE
      if (type === 'u') {
        // U FAG
        for (let i = 0; i < length; i++) {
          let item = groups[i] || {}
          if (item.membership?.active && item.type === 'fc:fs:emne') {
            if (item.membership?.basic === 'owner') {
              feideGroups.push(item)
            }
          }
        }
      } else if (type === 'b') {
        // B GRUPPER
        for (let i = 0; i < length; i++) {
          let item = groups[i] || {}
          if (
            item.membership?.active &&
            (item.type === 'fc:fs:prg' ||
              item.type === 'fc:fs:kull' ||
              item.type === 'fc:fs:klasse')
          ) {
            if (item.membership?.basic === 'owner') {
              feideGroups.push(item)
            }
          }
        }
      }
    }
    return feideGroups
  }

  getFeideOrgGroups(groups) {
    // console.log('getFeideOrgGroups')
    //  console.log(groups)
    let feideOrgGroups = []
    // groups.forEach((value, index, array) => {
    ;(Array.isArray(groups) ? groups : []).forEach((value) => {
      if (
        value !== undefined &&
        value.type !== undefined &&
        value.type === 'fc:org'
      ) {
        console.log('==== WE HAVE FC:ORG === ' + value.type)
        // console.log(value)
        feideOrgGroups.push(value)
      }
    })
    return feideOrgGroups
  }

  getFeideEnrichUGroup(uGroups) {
    console.log('getFeideEnrichUGroup got called')
    //  let enrichedGroups = []
    //    uGroups.forEach((value, index, array) => {
    uGroups.forEach((value) => {
      console.error('*** NOT USED *** getFeideEnrichUGroup (%j)', value)
    })
  }

  getFeideNorEduOrgNin(groups) {
    console.log('getFeideNorEduOrgNin got called')
    let municipalityNorEduOrgNin = ''
    let municipalityDisplayName = ''
    let schoolNorEduOrgNin = ''
    let schoolDisplayName = ''
    //    groups.forEach((value, index) => {
    ;(Array.isArray(groups) ? groups : []).forEach((value) => {
      if (value?.type === 'fc:org') {
        const orgType = (value.orgType || [])[0]
        // console.log('================ FC:ORG ==========')
        // console.log(JSON.stringify(value))
        if (orgType === 'primary_and_lower_secondary_owner') {
          municipalityNorEduOrgNin = value.norEduOrgNIN
          municipalityDisplayName = value.displayName
          schoolNorEduOrgNin = value.norEduOrgNIN
        } else if (orgType === 'upper_secondary_owner') {
          municipalityNorEduOrgNin = value.norEduOrgNIN
          municipalityDisplayName = value.displayName || ''
          schoolNorEduOrgNin = value.norEduOrgNIN
        } else if (orgType === 'higher_education') {
          municipalityNorEduOrgNin = value.norEduOrgNIN
          municipalityDisplayName = value.displayName
          schoolDisplayName = value.displayName
          schoolNorEduOrgNin = value.norEduOrgNIN
        } else if (orgType === 'primary_and_lower_secondary') {
          schoolDisplayName = value.displayName
          let id = value.id || ''
          let idSplit = id.split(':')
          // console.log(idSplit)
          schoolNorEduOrgNin = idSplit[4] || ''
        } else if (orgType === 'upper_secondary') {
          schoolDisplayName = value.displayName
          let id = value.id || ''
          let idSplit = id.split(':')
          // console.log(idSplit)
          schoolNorEduOrgNin = idSplit[4] || ''
        }
      }
    })
    return {
      municipalityNorEduOrgNin: municipalityNorEduOrgNin,
      municipalityDisplayName: municipalityDisplayName,
      schoolNorEduOrgNin: schoolNorEduOrgNin,
      schoolDisplayName: schoolDisplayName
    }
  }

  getFeideSchoolClass(bGroups) {
    /* fc:gogroup:spusers.feide.no:b:NO856326499:10a:2016-01-01:2019-06-20 */
    let bId = ''
    //    bGroups.forEach((value, index) => {
    ;(Array.isArray(bGroups) ? bGroups : []).forEach((value) => {
      bId = value?.id || bId
    })
    //    console.log('=== BID === (' + bId + ')')
    let idSplit = bId.split(':')
    let eduNIN = idSplit[5] || ''
    return eduNIN.toUpperCase()
  }
}

export function isAuthenticated() {
  let tokenExpiration = localStorage.getItem('tokenexpire')
  return !!tokenExpiration && tokenExpiration < new Date()
}

function isTokenExpired(token) {
  let expirationDate = getTokenExpirationDate(token)
  return expirationDate < new Date()
}

function getTokenExpirationDate(encodedToken) {
  let date = new Date(0)
  date.setUTCSeconds(encodedToken)
  return date
}
